export enum SelectionType {
    Website = 1, // can add different types in case we select app, keyword ...
}
export type WebsiteType = {
    domain: string;
    favicon: string;
    // Component ID is used to get the correct duration object from the swSettings component config
    // If not set and current component settings lacks the config it will use the global settings from Home
    componentId?: string;
    // TODO: Add more properties in case of a need
};
export type QualificationSideBarSelectionType = {
    type: SelectionType;
    data: WebsiteType; // can add different type of data ie: WebsiteType | AppType ...
};
